var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[(_vm.shouldShowLoader)?_c('Loader'):_vm._e(),_vm._v(" "),(_vm.showHeaderAndFooter)?_c('HeaderBar'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.showHeaderAndFooter)?_c('FooterBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }